import AssessmentDropzone from "./assessment-dropzone";
import DialogWrapper from "../../custom-ui/dialog/Dialog";
function AssessmentBadge(props) {
  return (
    <>
      <DialogWrapper title="Add Badge Image" onClose={props.toggleModal}>
        <p className="my-6 text-slate-500  leading-relaxed text-sm flex justify-center">
          Tap the image to open file explorer or Drop image below
        </p>
        <AssessmentDropzone closeModal={props.toggleModal} />
      </DialogWrapper>
    </>
  );
}

export default AssessmentBadge;
